import * as Actions     from '../actions/creators';

class Products {
    constructor(props, componentProps, dispatch, selectors, t, redux = {}) {
        this.name               = 'Products';
        this.props              = props;
        this.dispatch           = dispatch;
        this.componentProps     = componentProps;
        this.redux              = redux;
        this.t                  = t;
        this.selectors          = selectors;

        if (props && props.onMount) {
            this.onMount()
        }
    }

    onMount() {
        this.props.onMount();
    }

    getProductDomainData(payload) {
        this.dispatch(Actions.getProductDomainData(payload));
    }

    changeSorting(payload) {
        this.dispatch(Actions.changeSorting(payload));
    }

    addFilter(payload) {
        this.dispatch(Actions.addFilter(payload));
    }

    removeFilter(payload) {
        this.dispatch(Actions.removeFilter(payload));
    }

    changeCategoryFilter(payload) {
        this.dispatch(Actions.changeCategoryFilter(payload));
    }

    changePage(payload) {
        this.dispatch(Actions.changePage(payload));
    }

    addProductToCart(payload) {
        this.dispatch(Actions.addProductToCart(payload));
    }

    changeProductInCart(payload) {
        this.dispatch(Actions.changeProductInCart(payload));
    }

    removeProductFromCart(payload) {
        this.dispatch(Actions.removeProductFromCart(payload));
    }
}

export default Products;